import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Auth } from '../../../../../autentication/Auth';
import { Router } from '@angular/router';
import { CreditCardService } from '../../../../../shared/cards/credit-card.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-cards-credit-activation-step1',
	templateUrl: './step1.component.html',
	styleUrls: ['./step1.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class CardsCreditActivationStep1Component implements OnInit {
	public userName: string;
	public img: any;

	constructor(private router: Router, private creditCardService: CreditCardService, private sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		this.userName = Auth.getInstance().getUser().loggedUserName;
		this.getImgBannerCreditCard();
	}

	getImgBannerCreditCard() {
		this.img = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.creditCardService.creditCardImg);
	}

	goToNextTab = () => this.router.navigate(['cartoes-ativacao/credito/step2']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards-activation/credit/activation/step1/step1.component.ts